import createBaseService from "@/api/base-service.ts";
import type { CaseDocument } from "../../types/documents";

const caseDocumentService = {
	...createBaseService<CaseDocument>("/backoffice/case-documents"),
};

export default caseDocumentService;
